
export const API_URL = 'http://api.casta.astwarehosting.com/api';
export const APP_URL = 'http://api.casta.astwarehosting.com';

